export default __webpack_public_path__ + "static/media/usinage.af0afbdd.svg";